<template>
  <transition
    :name="transition"
    mode="in-out"
    appear
    :appear-active-class="enterClass"
    :enter-active-class="enterClass"
    :leave-active-class="leaveClass"
    @after-leave="afterLeave"
  >
    <div :class="['modal', 'animated', show ? 'is-active' : '']" v-if="show">
      <div class="modal-background" @click=""></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ title }}</p>
          <button class="delete" @click="cancel"></button>
        </header>
        <section class="modal-card-body">
          <slot></slot>
        </section>
        <footer class="modal-card-foot">
          <a class="button card-modal-ok-btn is-primary" 
             :class="{ 'is-disabled' : disableOk, 'is-loading' : btnIsLoading }"
             @click="ok"
          >{{ okText }}</a>
          <a class="button card-modal-preview-btn is-info" 
             :class="{ 'is-disabled' : disablePreview }" 
             @click="preview" 
             v-if="showPreview"
          >{{ previewText }}</a>
          <a class="button card-modal-cancel-btn" 
             @click="cancel"
          >{{ cancelText }}</a>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import BaseModal from './BaseModal'

export default {
  mixins: [BaseModal],

  props: {
    title: {
      type: String
    },
    disableOk: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: 'Submeter'
    },
    disablePreview: {
      type: Boolean,
      default: true
    },
    showPreview: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: 'Cancelar'
    }
  },

  mounted () {
    window.store.dispatch('deactivateScroll')
  },

  data () {
    return {
      previewText: 'Pré-visualizar',
      previewActive: false,
      auxScroll: 0
    }
  },

  currentEvent () {
    return window.store.state.event.nextEvent
  },

  watch: {
    currentEvent: function (val) {
      if (val === 'modal-card-close') {
        this.close()
        this.$destroy()
      }
    },

    scrollEnabled: function (val) {
      if (!val) {
        this.auxScroll = window.scrollY
        document.getElementById('app').classList.add('model-open')
        document.getElementById('app').style.marginTop = '-' + this.auxScroll + 'px'
      } else {
        document.getElementById('app').style.marginTop = '0'
        document.getElementById('app').classList.remove('model-open')
        document.body.scrollTop = this.auxScroll
      }
    }
  },

  computed: {
    scrollEnabled () {
      return window.store.state.config.scrollEnabled
    },
    btnIsLoading () {
      if (window.store.state.notification.loadingButtons.includes('.card-modal-ok-btn')) {
        return true
      }
      return false
    }
  },

  methods: {
    ok () {
      window.store.dispatch('newEvent', 'modal-card-ok')
      window.store.dispatch('activateScroll')
    },

    preview () {
      this.previewActive = !this.previewActive
      window.store.dispatch('newEvent', 'modal-card-preview')

      if (this.previewActive) {
        this.previewText = 'Editar'
      } else {
        this.previewText = 'Pré-visualizar'
      }
    },

    cancel () {
      window.store.dispatch('newEvent', 'modal-card-cancel')
      window.store.dispatch('activateScroll')
    }
  }
}
</script>



// WEBPACK FOOTER //
// CardModal.vue?1f35b4e3